import type {CommentDto} from '../api'
import {CommentStatus} from '../api'

/**
 * Returns the last modified date and user for a comment.
 * For edited comments, returns updatedOn/updatedBy.
 * For new comments, returns createdOn/createdBy.
 */
export const getCommentLastModified = (comment: CommentDto): {date: string; user: string} => {
  if (comment.status === CommentStatus.Edited) {
    return {date: comment.updatedOn, user: comment.updatedBy}
  }
  return {date: comment.createdOn, user: comment.createdBy}
}
